<template>
  <div>
    <Slider maxHeight="150px" type="LoginPage" class="slider" />
    <CenteredContainer>
      <SfHeading class="sf-heading--left m-b-20" :level="2" :title="$t('Register')" />
      <form @submit.prevent="registerUser" class="fz-form">
        <div class="row">
          <div class="col-xs-12">
            <SfHeading class="sf-heading--left" :level="3" :title="$t('Basic Information')" />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="FirstName" name="firstName" :label="$t('First Name')" required />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="LastName" name="lastName" :label="$t('Last Name')" required />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="Email" type="email" name="email" label="E-mail" required />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="Phone" name="phone" :label="$t('Phone')" type="tel" />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="Company" name="company" :label="$t('Company')" />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="VatNumber" name="VatNumber" :label="$t('Vat Number')" />
          </div>
          <div class="col-xs-12">
            <SfHeading class="sf-heading--left" :level="3" :title="$t('Password')" />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput
              v-model="Password"
              name="password"
              :label="$t('Password')"
              type="password"
              :has-show-password="true"
              minlength="6"
              required
            />
          </div>
          <div class="col-xs-12">
            <SfHeading class="sf-heading--left" :level="3" :title="$t('Default Address')" />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput
              v-model="StreetAddress"
              name="streetAddress"
              :label="$t('Street Address')"
              required
            />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput
              v-model="StreetAddress2"
              name="streetAddress2"
              :label="$t('Second Street Address')"
              required
            />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="City" name="city" :label="$t('City')" required />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfInput v-model="ZipPostalCode" name="zipCode" :label="$t('Zip-code')" required />
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfSelect
              class="sf-select--underlined"
              v-model="CountryId"
              name="CountryId"
              :label="$t('Country')"
              :placeholder="$t('Select option')"
              required
            >
              <SfSelectOption v-for="country in countries" :key="country.Id" :value="country.Id">
                {{ country.Name }}
              </SfSelectOption>
            </SfSelect>
          </div>
          <div class="col-xs-12 col-sm-6">
            <SfSelect
              :key="CountryId"
              class="sf-select--underlined"
              v-model="StateProvinceId"
              name="StateProvinceId"
              :label="$t('State Province')"
              :placeholder="$t('Select option')"
              :disabled="!countryStateProvince.length"
              :required="!countryStateProvince.length"
            >
              <SfSelectOption
                v-for="state in countryStateProvince"
                :key="state.Id"
                :value="state.Id"
              >
                {{ state.Name }}
              </SfSelectOption>
            </SfSelect>
          </div>
          <div class="col-xs-12 error" v-if="errors.length">
            <p v-for="(error, key) in errors" :key="key" class="error m-b-5">
              {{ error }}
            </p>
          </div>
          <div class="col-xs-12">
            <SfButton type="submit" class="sf-button--full-width form__submit">
              {{ $t('Create an account') }}
            </SfButton>
          </div>
        </div>
      </form>
      <SfButton @click="goToLogin" class="sf-button--text action-button">
        {{ $t('or Log In To Your Account') }}
      </SfButton>
    </CenteredContainer>
  </div>
</template>
<script>
import {
  SfInput, SfButton, SfSelect, SfHeading,
} from '@storefront-ui/vue';
import { config, Slider } from '@/modules/core';
import user from '../mixins/user';
import CenteredContainer from '../components/CenteredContainer.vue';

const userModel = {
  Email: '',
  Password: '',
  FirstName: '',
  LastName: '',
  Company: '',
  StreetAddress: '',
  StreetAddress2: '',
  ZipPostalCode: '',
  City: '',
  CountryId: '',
  StateProvinceId: '',
  Phone: '',
  Newsletter: false,
  VatNumber: '',
};

export default {
  name: 'Register',
  mixins: [user, config],
  components: {
    SfInput,
    SfButton,
    SfSelect,
    SfHeading,
    CenteredContainer,
    Slider,
  },
  data() {
    return {
      ...userModel,
      errors: [],
    };
  },
  methods: {
    registerUser() {
      const data = Object.keys(userModel).reduce(
        (acc, curr) => ({
          [curr]: this[curr],
          ...acc,
        }),
        {},
      );
      this.register(data)
        .then(() => {
          this.goToLogin();
        })
        .catch((err) => {
          this.setErrors(err.response.data.errors);
          console.log(err.response);
        });
    },
    setErrors(errors) {
      this.errors = Object.keys(errors).map((error) => errors[error][0]);
    },
    goToLogin() {
      this.$router.push('/login');
    },
  },
  watch: {
    CountryId() {
      this.countryStateProvince = this.filterStateProvince(this.CountryId);
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
  &__element {
    margin: var(--spacer-base) 0;
  }
  &__checkbox {
    margin: var(--spacer-xl) 0 var(--spacer-2xl) 0;
  }
  &__submit {
    margin: var(--spacer-xl) 0 0 0;
  }
}
.action-button {
  margin: var(--spacer-xl) 0;
}

.error {
  color: var(--c-danger);
}

.aside {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 var(--spacer-xl) 0;
  &__heading {
    --heading-title-color: var(--c-primary);
    margin: 0 0 var(--spacer-sm) 0;
  }
}

.slider {
  margin-bottom: 20px;
}
</style>
